'use client';

import React from 'react';
import { Menu, MenuButton, MenuItems } from '@headlessui/react';
import parse from 'html-react-parser';
import classNames from 'classnames';
import { ChevronUpIcon } from '@heroicons/react/16/solid';
import { getLinkClasses, getLinkStyle } from '../Link/Link';
import StaticIcon from '../Link/Icon';
import Flag from '../../static/Flag';

export default function Dropdown(props) {
	const { children, settings, text, iconBefore, ...rest } = props;
	return (
		<Menu as="div" className="block text-left">
			{({ open }) => (
				<>
					<MenuButton className={getLinkClasses(rest, settings)} style={getLinkStyle(rest, settings)}>
						<div className="inline-flex items-center align-middle text-center gap-x-2">
							{iconBefore && (iconBefore.length === 2 ? <Flag code={iconBefore} /> : <StaticIcon value={iconBefore} />)}
							{parse(text)}
							<ChevronUpIcon className={classNames({ 'rotate-180 transform': !open }, 'h-5 w-5 font-semibold')} />
						</div>
					</MenuButton>
					<MenuItems
						anchor="bottom"
						className="min-w-[50px] z-50 mt-2 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
					>
						{children}
					</MenuItems>
				</>
			)}
		</Menu>
	);
}
